webpackJsonp([114276838955818,60335399758886],{

/***/ 123:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(262);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(123);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(35);
	var isArguments = __webpack_require__(34);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 34:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(42);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(33);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(41);
	
	var _HelmetConstants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(3);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(36);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(43);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.BrowserSpriteSymbol = factory());
	}(this, (function () { 'use strict';
	
	var SpriteSymbol = function SpriteSymbol(ref) {
	  var id = ref.id;
	  var viewBox = ref.viewBox;
	  var content = ref.content;
	
	  this.id = id;
	  this.viewBox = viewBox;
	  this.content = content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.stringify = function stringify () {
	  return this.content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	SpriteSymbol.prototype.destroy = function destroy () {
	    var this$1 = this;
	
	  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
	};
	
	/**
	 * @param {string} content
	 * @return {Element}
	 */
	var parse = function (content) {
	  var hasImportNode = !!document.importNode;
	  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;
	
	  /**
	   * Fix for browser which are throwing WrongDocumentError
	   * if you insert an element which is not part of the document
	   * @see http://stackoverflow.com/a/7986519/4624403
	   */
	  if (hasImportNode) {
	    return document.importNode(doc, true);
	  }
	
	  return doc;
	};
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var index = createCommonjsModule(function (module, exports) {
	(function (root, factory) {
	    if (false) {
	        undefined(factory);
	    } else {
	        module.exports = factory();
	    }
	}(commonjsGlobal, function () {
	
	function isMergeableObject(val) {
	    var nonNullObject = val && typeof val === 'object';
	
	    return nonNullObject
	        && Object.prototype.toString.call(val) !== '[object RegExp]'
	        && Object.prototype.toString.call(val) !== '[object Date]'
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function (key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function (key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var array = Array.isArray(source);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var arrayMerge = options.arrayMerge || defaultArrayMerge;
	
	    if (array) {
	        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	return deepmerge
	
	}));
	});
	
	var namespaces_1 = createCommonjsModule(function (module, exports) {
	var namespaces = {
	  svg: {
	    name: 'xmlns',
	    uri: 'http://www.w3.org/2000/svg'
	  },
	  xlink: {
	    name: 'xmlns:xlink',
	    uri: 'http://www.w3.org/1999/xlink'
	  }
	};
	
	exports.default = namespaces;
	module.exports = exports.default;
	});
	
	/**
	 * @param {Object} attrs
	 * @return {string}
	 */
	var objectToAttrsString = function (attrs) {
	  return Object.keys(attrs).map(function (attr) {
	    var value = attrs[attr].toString().replace(/"/g, '&quot;');
	    return (attr + "=\"" + value + "\"");
	  }).join(' ');
	};
	
	var svg = namespaces_1.svg;
	var xlink = namespaces_1.xlink;
	
	var defaultAttrs = {};
	defaultAttrs[svg.name] = svg.uri;
	defaultAttrs[xlink.name] = xlink.uri;
	
	/**
	 * @param {string} [content]
	 * @param {Object} [attributes]
	 * @return {string}
	 */
	var wrapInSvgString = function (content, attributes) {
	  if ( content === void 0 ) content = '';
	
	  var attrs = index(defaultAttrs, attributes || {});
	  var attrsRendered = objectToAttrsString(attrs);
	  return ("<svg " + attrsRendered + ">" + content + "</svg>");
	};
	
	var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
	  function BrowserSpriteSymbol () {
	    SpriteSymbol$$1.apply(this, arguments);
	  }
	
	  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
	  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
	  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * @param {Element} node
	   * @return {BrowserSpriteSymbol}
	   */
	  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
	    return new BrowserSpriteSymbol({
	      id: node.getAttribute('id'),
	      viewBox: node.getAttribute('viewBox'),
	      content: node.outerHTML
	    });
	  };
	
	  BrowserSpriteSymbol.prototype.destroy = function destroy () {
	    if (this.isMounted) {
	      this.unmount();
	    }
	    SpriteSymbol$$1.prototype.destroy.call(this);
	  };
	
	  /**
	   * @param {Element|string} target
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.mount = function mount (target) {
	    if (this.isMounted) {
	      return this.node;
	    }
	
	    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = this.render();
	    this.node = node;
	
	    mountTarget.appendChild(node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.render = function render () {
	    var content = this.stringify();
	    return parse(wrapInSvgString(content)).childNodes[0];
	  };
	
	  BrowserSpriteSymbol.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );
	
	  return BrowserSpriteSymbol;
	}(SpriteSymbol));
	
	return BrowserSpriteSymbol;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.BrowserSprite = factory());
	}(this, (function () { 'use strict';
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var index = createCommonjsModule(function (module, exports) {
	(function (root, factory) {
	    if (false) {
	        undefined(factory);
	    } else {
	        module.exports = factory();
	    }
	}(commonjsGlobal, function () {
	
	function isMergeableObject(val) {
	    var nonNullObject = val && typeof val === 'object';
	
	    return nonNullObject
	        && Object.prototype.toString.call(val) !== '[object RegExp]'
	        && Object.prototype.toString.call(val) !== '[object Date]'
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function (key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function (key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var array = Array.isArray(source);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var arrayMerge = options.arrayMerge || defaultArrayMerge;
	
	    if (array) {
	        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	return deepmerge
	
	}));
	});
	
	//      
	// An event handler can take an optional event argument
	// and should not return a value
	                                          
	// An array of all currently registered event handlers for a type
	                                            
	// A map of event types and their corresponding event handlers.
	                        
	                                   
	  
	
	/** Mitt: Tiny (~200b) functional event emitter / pubsub.
	 *  @name mitt
	 *  @returns {Mitt}
	 */
	function mitt(all                 ) {
		all = all || Object.create(null);
	
		return {
			/**
			 * Register an event handler for the given type.
			 *
			 * @param  {String} type	Type of event to listen for, or `"*"` for all events
			 * @param  {Function} handler Function to call in response to given event
			 * @memberOf mitt
			 */
			on: function on(type        , handler              ) {
				(all[type] || (all[type] = [])).push(handler);
			},
	
			/**
			 * Remove an event handler for the given type.
			 *
			 * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
			 * @param  {Function} handler Handler function to remove
			 * @memberOf mitt
			 */
			off: function off(type        , handler              ) {
				if (all[type]) {
					all[type].splice(all[type].indexOf(handler) >>> 0, 1);
				}
			},
	
			/**
			 * Invoke all handlers for the given type.
			 * If present, `"*"` handlers are invoked after type-matched handlers.
			 *
			 * @param {String} type  The event type to invoke
			 * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
			 * @memberof mitt
			 */
			emit: function emit(type        , evt     ) {
				(all[type] || []).map(function (handler) { handler(evt); });
				(all['*'] || []).map(function (handler) { handler(type, evt); });
			}
		};
	}
	
	var namespaces_1 = createCommonjsModule(function (module, exports) {
	var namespaces = {
	  svg: {
	    name: 'xmlns',
	    uri: 'http://www.w3.org/2000/svg'
	  },
	  xlink: {
	    name: 'xmlns:xlink',
	    uri: 'http://www.w3.org/1999/xlink'
	  }
	};
	
	exports.default = namespaces;
	module.exports = exports.default;
	});
	
	/**
	 * @param {Object} attrs
	 * @return {string}
	 */
	var objectToAttrsString = function (attrs) {
	  return Object.keys(attrs).map(function (attr) {
	    var value = attrs[attr].toString().replace(/"/g, '&quot;');
	    return (attr + "=\"" + value + "\"");
	  }).join(' ');
	};
	
	var svg = namespaces_1.svg;
	var xlink = namespaces_1.xlink;
	
	var defaultAttrs = {};
	defaultAttrs[svg.name] = svg.uri;
	defaultAttrs[xlink.name] = xlink.uri;
	
	/**
	 * @param {string} [content]
	 * @param {Object} [attributes]
	 * @return {string}
	 */
	var wrapInSvgString = function (content, attributes) {
	  if ( content === void 0 ) content = '';
	
	  var attrs = index(defaultAttrs, attributes || {});
	  var attrsRendered = objectToAttrsString(attrs);
	  return ("<svg " + attrsRendered + ">" + content + "</svg>");
	};
	
	var svg$1 = namespaces_1.svg;
	var xlink$1 = namespaces_1.xlink;
	
	var defaultConfig = {
	  attrs: ( obj = {
	    style: ['position: absolute', 'width: 0', 'height: 0'].join('; ')
	  }, obj[svg$1.name] = svg$1.uri, obj[xlink$1.name] = xlink$1.uri, obj )
	};
	var obj;
	
	var Sprite = function Sprite(config) {
	  this.config = index(defaultConfig, config || {});
	  this.symbols = [];
	};
	
	/**
	 * Add new symbol. If symbol with the same id exists it will be replaced.
	 * @param {SpriteSymbol} symbol
	 * @return {boolean} `true` - symbol was added, `false` - replaced
	 */
	Sprite.prototype.add = function add (symbol) {
	  var ref = this;
	    var symbols = ref.symbols;
	  var existing = this.find(symbol.id);
	
	  if (existing) {
	    symbols[symbols.indexOf(existing)] = symbol;
	    return false;
	  }
	
	  symbols.push(symbol);
	  return true;
	};
	
	/**
	 * Remove symbol & destroy it
	 * @param {string} id
	 * @return {boolean} `true` - symbol was found & successfully destroyed, `false` - otherwise
	 */
	Sprite.prototype.remove = function remove (id) {
	  var ref = this;
	    var symbols = ref.symbols;
	  var symbol = this.find(id);
	
	  if (symbol) {
	    symbols.splice(symbols.indexOf(symbol), 1);
	    symbol.destroy();
	    return true;
	  }
	
	  return false;
	};
	
	/**
	 * @param {string} id
	 * @return {SpriteSymbol|null}
	 */
	Sprite.prototype.find = function find (id) {
	  return this.symbols.filter(function (s) { return s.id === id; })[0] || null;
	};
	
	/**
	 * @param {string} id
	 * @return {boolean}
	 */
	Sprite.prototype.has = function has (id) {
	  return this.find(id) !== null;
	};
	
	/**
	 * @return {string}
	 */
	Sprite.prototype.stringify = function stringify () {
	  var ref = this.config;
	    var attrs = ref.attrs;
	  var stringifiedSymbols = this.symbols.map(function (s) { return s.stringify(); }).join('');
	  return wrapInSvgString(stringifiedSymbols, attrs);
	};
	
	/**
	 * @return {string}
	 */
	Sprite.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	Sprite.prototype.destroy = function destroy () {
	  this.symbols.forEach(function (s) { return s.destroy(); });
	};
	
	var SpriteSymbol = function SpriteSymbol(ref) {
	  var id = ref.id;
	  var viewBox = ref.viewBox;
	  var content = ref.content;
	
	  this.id = id;
	  this.viewBox = viewBox;
	  this.content = content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.stringify = function stringify () {
	  return this.content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	SpriteSymbol.prototype.destroy = function destroy () {
	    var this$1 = this;
	
	  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
	};
	
	/**
	 * @param {string} content
	 * @return {Element}
	 */
	var parse = function (content) {
	  var hasImportNode = !!document.importNode;
	  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;
	
	  /**
	   * Fix for browser which are throwing WrongDocumentError
	   * if you insert an element which is not part of the document
	   * @see http://stackoverflow.com/a/7986519/4624403
	   */
	  if (hasImportNode) {
	    return document.importNode(doc, true);
	  }
	
	  return doc;
	};
	
	var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
	  function BrowserSpriteSymbol () {
	    SpriteSymbol$$1.apply(this, arguments);
	  }
	
	  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
	  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
	  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * @param {Element} node
	   * @return {BrowserSpriteSymbol}
	   */
	  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
	    return new BrowserSpriteSymbol({
	      id: node.getAttribute('id'),
	      viewBox: node.getAttribute('viewBox'),
	      content: node.outerHTML
	    });
	  };
	
	  BrowserSpriteSymbol.prototype.destroy = function destroy () {
	    if (this.isMounted) {
	      this.unmount();
	    }
	    SpriteSymbol$$1.prototype.destroy.call(this);
	  };
	
	  /**
	   * @param {Element|string} target
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.mount = function mount (target) {
	    if (this.isMounted) {
	      return this.node;
	    }
	
	    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = this.render();
	    this.node = node;
	
	    mountTarget.appendChild(node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.render = function render () {
	    var content = this.stringify();
	    return parse(wrapInSvgString(content)).childNodes[0];
	  };
	
	  BrowserSpriteSymbol.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );
	
	  return BrowserSpriteSymbol;
	}(SpriteSymbol));
	
	var defaultConfig$1 = {
	  /**
	   * Should following options be automatically configured:
	   * - `syncUrlsWithBaseTag`
	   * - `locationChangeAngularEmitter`
	   * - `moveGradientsOutsideSymbol`
	   * @type {boolean}
	   */
	  autoConfigure: true,
	
	  /**
	   * Default mounting selector
	   * @type {string}
	   */
	  mountTo: 'body',
	
	  /**
	   * Fix disappearing SVG elements when <base href> exists.
	   * Executes when sprite mounted.
	   * @see http://stackoverflow.com/a/18265336/796152
	   * @see https://github.com/everdimension/angular-svg-base-fix
	   * @see https://github.com/angular/angular.js/issues/8934#issuecomment-56568466
	   * @type {boolean}
	   */
	  syncUrlsWithBaseTag: false,
	
	  /**
	   * Should sprite listen custom location change event
	   * @type {boolean}
	   */
	  listenLocationChangeEvent: true,
	
	  /**
	   * Custom window event name which should be emitted to update sprite urls
	   * @type {string}
	   */
	  locationChangeEvent: 'locationChange',
	
	  /**
	   * Emit location change event in Angular automatically
	   * @type {boolean}
	   */
	  locationChangeAngularEmitter: false,
	
	  /**
	   * Selector to find symbols usages when updating sprite urls
	   * @type {string}
	   */
	  usagesToUpdate: 'use[*|href]',
	
	  /**
	   * Fix Firefox bug when gradients and patterns don't work if they are within a symbol.
	   * Executes when sprite is rendered, but not mounted.
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=306674
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=353575
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1235364
	   * @type {boolean}
	   */
	  moveGradientsOutsideSymbol: false
	};
	
	/**
	 * @param {*} arrayLike
	 * @return {Array}
	 */
	var arrayFrom = function (arrayLike) {
	  return Array.prototype.slice.call(arrayLike, 0);
	};
	
	var ua = navigator.userAgent;
	
	var browser = {
	  isChrome: /chrome/i.test(ua),
	  isFirefox: /firefox/i.test(ua),
	
	  // https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
	  isIE: /msie/i.test(ua) || /trident/i.test(ua),
	  isEdge: /edge/i.test(ua)
	};
	
	/**
	 * @param {string} name
	 * @param {*} data
	 */
	var dispatchEvent = function (name, data) {
	  var event = document.createEvent('CustomEvent');
	  event.initCustomEvent(name, false, false, data);
	  window.dispatchEvent(event);
	};
	
	/**
	 * IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
	 * This trick will trigger IE to read and use any existing SVG <style> tags.
	 * @see https://github.com/iconic/SVGInjector/issues/23
	 * @see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10898469/
	 *
	 * @param {Element} node DOM Element to search <style> tags in
	 * @return {Array<HTMLStyleElement>}
	 */
	var evalStylesIEWorkaround = function (node) {
	  var updatedNodes = [];
	
	  arrayFrom(node.querySelectorAll('style'))
	    .forEach(function (style) {
	      style.textContent += '';
	      updatedNodes.push(style);
	    });
	
	  return updatedNodes;
	};
	
	/**
	 * @param {string} [url] If not provided - current URL will be used
	 * @return {string}
	 */
	var getUrlWithoutFragment = function (url) {
	  return (url || window.location.href).split('#')[0];
	};
	
	/* global angular */
	/**
	 * @param {string} eventName
	 */
	var locationChangeAngularEmitter = function (eventName) {
	  angular.module('ng').run(['$rootScope', function ($rootScope) {
	    $rootScope.$on('$locationChangeSuccess', function (e, newUrl, oldUrl) {
	      dispatchEvent(eventName, { oldUrl: oldUrl, newUrl: newUrl });
	    });
	  }]);
	};
	
	var defaultSelector = 'linearGradient, radialGradient, pattern';
	
	/**
	 * @param {Element} svg
	 * @param {string} [selector]
	 * @return {Element}
	 */
	var moveGradientsOutsideSymbol = function (svg, selector) {
	  if ( selector === void 0 ) selector = defaultSelector;
	
	  arrayFrom(svg.querySelectorAll('symbol')).forEach(function (symbol) {
	    arrayFrom(symbol.querySelectorAll(selector)).forEach(function (node) {
	      symbol.parentNode.insertBefore(node, symbol);
	    });
	  });
	  return svg;
	};
	
	/**
	 * @param {NodeList} nodes
	 * @param {Function} [matcher]
	 * @return {Attr[]}
	 */
	function selectAttributes(nodes, matcher) {
	  var attrs = arrayFrom(nodes).reduce(function (acc, node) {
	    if (!node.attributes) {
	      return acc;
	    }
	
	    var arrayfied = arrayFrom(node.attributes);
	    var matched = matcher ? arrayfied.filter(matcher) : arrayfied;
	    return acc.concat(matched);
	  }, []);
	
	  return attrs;
	}
	
	/**
	 * @param {NodeList|Node} nodes
	 * @param {boolean} [clone=true]
	 * @return {string}
	 */
	
	var xLinkNS = namespaces_1.xlink.uri;
	var xLinkAttrName = 'xlink:href';
	
	// eslint-disable-next-line no-useless-escape
	var specialUrlCharsPattern = /[{}|\\\^\[\]`"<>]/g;
	
	function encoder(url) {
	  return url.replace(specialUrlCharsPattern, function (match) {
	    return ("%" + (match[0].charCodeAt(0).toString(16).toUpperCase()));
	  });
	}
	
	/**
	 * @param {NodeList} nodes
	 * @param {string} startsWith
	 * @param {string} replaceWith
	 * @return {NodeList}
	 */
	function updateReferences(nodes, startsWith, replaceWith) {
	  arrayFrom(nodes).forEach(function (node) {
	    var href = node.getAttribute(xLinkAttrName);
	    if (href && href.indexOf(startsWith) === 0) {
	      var newUrl = href.replace(startsWith, replaceWith);
	      node.setAttributeNS(xLinkNS, xLinkAttrName, newUrl);
	    }
	  });
	
	  return nodes;
	}
	
	/**
	 * List of SVG attributes to update url() target in them
	 */
	var attList = [
	  'clipPath',
	  'colorProfile',
	  'src',
	  'cursor',
	  'fill',
	  'filter',
	  'marker',
	  'markerStart',
	  'markerMid',
	  'markerEnd',
	  'mask',
	  'stroke',
	  'style'
	];
	
	var attSelector = attList.map(function (attr) { return ("[" + attr + "]"); }).join(',');
	
	/**
	 * Update URLs in svg image (like `fill="url(...)"`) and update referencing elements
	 * @param {Element} svg
	 * @param {NodeList} references
	 * @param {string|RegExp} startsWith
	 * @param {string} replaceWith
	 * @return {void}
	 *
	 * @example
	 * const sprite = document.querySelector('svg.sprite');
	 * const usages = document.querySelectorAll('use');
	 * updateUrls(sprite, usages, '#', 'prefix#');
	 */
	var updateUrls = function (svg, references, startsWith, replaceWith) {
	  var startsWithEncoded = encoder(startsWith);
	  var replaceWithEncoded = encoder(replaceWith);
	
	  var nodes = svg.querySelectorAll(attSelector);
	  var attrs = selectAttributes(nodes, function (ref) {
	    var localName = ref.localName;
	    var value = ref.value;
	
	    return attList.indexOf(localName) !== -1 && value.indexOf(("url(" + startsWithEncoded)) !== -1;
	  });
	
	  attrs.forEach(function (attr) { return attr.value = attr.value.replace(startsWithEncoded, replaceWithEncoded); });
	  updateReferences(references, startsWithEncoded, replaceWithEncoded);
	};
	
	/**
	 * Internal emitter events
	 * @enum
	 * @private
	 */
	var Events = {
	  MOUNT: 'mount',
	  SYMBOL_MOUNT: 'symbol_mount'
	};
	
	var BrowserSprite = (function (Sprite$$1) {
	  function BrowserSprite(cfg) {
	    var this$1 = this;
	    if ( cfg === void 0 ) cfg = {};
	
	    Sprite$$1.call(this, index(defaultConfig$1, cfg));
	
	    var emitter = mitt();
	    this._emitter = emitter;
	    this.node = null;
	
	    var ref = this;
	    var config = ref.config;
	
	    if (config.autoConfigure) {
	      this._autoConfigure(cfg);
	    }
	
	    if (config.syncUrlsWithBaseTag) {
	      var baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
	      emitter.on(Events.MOUNT, function () { return this$1.updateUrls('#', baseUrl); });
	    }
	
	    var handleLocationChange = this._handleLocationChange.bind(this);
	    this._handleLocationChange = handleLocationChange;
	
	    // Provide way to update sprite urls externally via dispatching custom window event
	    if (config.listenLocationChangeEvent) {
	      window.addEventListener(config.locationChangeEvent, handleLocationChange);
	    }
	
	    // Emit location change event in Angular automatically
	    if (config.locationChangeAngularEmitter) {
	      locationChangeAngularEmitter(config.locationChangeEvent);
	    }
	
	    // After sprite mounted
	    emitter.on(Events.MOUNT, function (spriteNode) {
	      if (config.moveGradientsOutsideSymbol) {
	        moveGradientsOutsideSymbol(spriteNode);
	      }
	    });
	
	    // After symbol mounted into sprite
	    emitter.on(Events.SYMBOL_MOUNT, function (symbolNode) {
	      if (config.moveGradientsOutsideSymbol) {
	        moveGradientsOutsideSymbol(symbolNode.parentNode);
	      }
	
	      if (browser.isIE || browser.isEdge) {
	        evalStylesIEWorkaround(symbolNode);
	      }
	    });
	  }
	
	  if ( Sprite$$1 ) BrowserSprite.__proto__ = Sprite$$1;
	  BrowserSprite.prototype = Object.create( Sprite$$1 && Sprite$$1.prototype );
	  BrowserSprite.prototype.constructor = BrowserSprite;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  /**
	   * @return {boolean}
	   */
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * Automatically configure following options
	   * - `syncUrlsWithBaseTag`
	   * - `locationChangeAngularEmitter`
	   * - `moveGradientsOutsideSymbol`
	   * @param {Object} cfg
	   * @private
	   */
	  BrowserSprite.prototype._autoConfigure = function _autoConfigure (cfg) {
	    var ref = this;
	    var config = ref.config;
	
	    if (typeof cfg.syncUrlsWithBaseTag === 'undefined') {
	      config.syncUrlsWithBaseTag = typeof document.getElementsByTagName('base')[0] !== 'undefined';
	    }
	
	    if (typeof cfg.locationChangeAngularEmitter === 'undefined') {
	      config.locationChangeAngularEmitter = 'angular' in window;
	    }
	
	    if (typeof cfg.moveGradientsOutsideSymbol === 'undefined') {
	      config.moveGradientsOutsideSymbol = browser.isFirefox;
	    }
	  };
	
	  /**
	   * @param {Event} event
	   * @param {Object} event.detail
	   * @param {string} event.detail.oldUrl
	   * @param {string} event.detail.newUrl
	   * @private
	   */
	  BrowserSprite.prototype._handleLocationChange = function _handleLocationChange (event) {
	    var ref = event.detail;
	    var oldUrl = ref.oldUrl;
	    var newUrl = ref.newUrl;
	    this.updateUrls(oldUrl, newUrl);
	  };
	
	  /**
	   * Add new symbol. If symbol with the same id exists it will be replaced.
	   * If sprite already mounted - `symbol.mount(sprite.node)` will be called.
	   * @fires Events#SYMBOL_MOUNT
	   * @param {BrowserSpriteSymbol} symbol
	   * @return {boolean} `true` - symbol was added, `false` - replaced
	   */
	  BrowserSprite.prototype.add = function add (symbol) {
	    var sprite = this;
	    var isNewSymbol = Sprite$$1.prototype.add.call(this, symbol);
	
	    if (this.isMounted && isNewSymbol) {
	      symbol.mount(sprite.node);
	      this._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
	    }
	
	    return isNewSymbol;
	  };
	
	  /**
	   * Attach to existing DOM node
	   * @param {string|Element} target
	   * @return {Element|null} attached DOM Element. null if node to attach not found.
	   */
	  BrowserSprite.prototype.attach = function attach (target) {
	    var this$1 = this;
	
	    var sprite = this;
	
	    if (sprite.isMounted) {
	      return sprite.node;
	    }
	
	    /** @type Element */
	    var node = typeof target === 'string' ? document.querySelector(target) : target;
	    sprite.node = node;
	
	    // Already added symbols needs to be mounted
	    this.symbols.forEach(function (symbol) {
	      symbol.mount(sprite.node);
	      this$1._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
	    });
	
	    // Create symbols from existing DOM nodes, add and mount them
	    arrayFrom(node.querySelectorAll('symbol'))
	      .forEach(function (symbolNode) {
	        var symbol = BrowserSpriteSymbol.createFromExistingNode(symbolNode);
	        symbol.node = symbolNode; // hack to prevent symbol mounting to sprite when adding
	        sprite.add(symbol);
	      });
	
	    this._emitter.emit(Events.MOUNT, node);
	
	    return node;
	  };
	
	  BrowserSprite.prototype.destroy = function destroy () {
	    var ref = this;
	    var config = ref.config;
	    var symbols = ref.symbols;
	    var _emitter = ref._emitter;
	
	    symbols.forEach(function (s) { return s.destroy(); });
	
	    _emitter.off('*');
	    window.removeEventListener(config.locationChangeEvent, this._handleLocationChange);
	
	    if (this.isMounted) {
	      this.unmount();
	    }
	  };
	
	  /**
	   * @fires Events#MOUNT
	   * @param {string|Element} [target]
	   * @param {boolean} [prepend=false]
	   * @return {Element|null} rendered sprite node. null if mount node not found.
	   */
	  BrowserSprite.prototype.mount = function mount (target, prepend) {
	    if ( target === void 0 ) target = this.config.mountTo;
	    if ( prepend === void 0 ) prepend = false;
	
	    var sprite = this;
	
	    if (sprite.isMounted) {
	      return sprite.node;
	    }
	
	    var mountNode = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = sprite.render();
	    this.node = node;
	
	    if (prepend && mountNode.childNodes[0]) {
	      mountNode.insertBefore(node, mountNode.childNodes[0]);
	    } else {
	      mountNode.appendChild(node);
	    }
	
	    this._emitter.emit(Events.MOUNT, node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSprite.prototype.render = function render () {
	    return parse(this.stringify());
	  };
	
	  /**
	   * Detach sprite from the DOM
	   */
	  BrowserSprite.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  /**
	   * Update URLs in sprite and usage elements
	   * @param {string} oldUrl
	   * @param {string} newUrl
	   * @return {boolean} `true` - URLs was updated, `false` - sprite is not mounted
	   */
	  BrowserSprite.prototype.updateUrls = function updateUrls$1 (oldUrl, newUrl) {
	    if (!this.isMounted) {
	      return false;
	    }
	
	    var usages = document.querySelectorAll(this.config.usagesToUpdate);
	
	    updateUrls(
	      this.node,
	      usages,
	      ((getUrlWithoutFragment(oldUrl)) + "#"),
	      ((getUrlWithoutFragment(newUrl)) + "#")
	    );
	
	    return true;
	  };
	
	  Object.defineProperties( BrowserSprite.prototype, prototypeAccessors );
	
	  return BrowserSprite;
	}(Sprite));
	
	var ready$1 = createCommonjsModule(function (module) {
	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  { module.exports = definition(); }
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);
	
	
	  if (!loaded)
	  { doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener);
	    loaded = 1;
	    while (listener = fns.shift()) { listener(); }
	  }); }
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn);
	  }
	
	});
	});
	
	var spriteNodeId = '__SVG_SPRITE_NODE__';
	var spriteGlobalVarName = '__SVG_SPRITE__';
	var isSpriteExists = !!window[spriteGlobalVarName];
	
	// eslint-disable-next-line import/no-mutable-exports
	var sprite;
	
	if (isSpriteExists) {
	  sprite = window[spriteGlobalVarName];
	} else {
	  sprite = new BrowserSprite({ attrs: { id: spriteNodeId } });
	  window[spriteGlobalVarName] = sprite;
	}
	
	var loadSprite = function () {
	  /**
	   * Check for page already contains sprite node
	   * If found - attach to and reuse it's content
	   * If not - render and mount the new sprite
	   */
	  var existing = document.getElementById(spriteNodeId);
	
	  if (existing) {
	    sprite.attach(existing);
	  } else {
	    sprite.mount(document.body, true);
	  }
	};
	
	if (document.body) {
	  loadSprite();
	} else {
	  ready$1(loadSprite);
	}
	
	var sprite$1 = sprite;
	
	return sprite$1;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(29);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        textAlign: 'center',
	        borderTop: '2px solid #5799a9',
	        padding: '24px'
	      }
	    },
	    _react2.default.createElement(
	      'p',
	      {
	        style: {
	          marginBottom: 0,
	          fontSize: '0.8em'
	        }
	      },
	      'Created with ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: 'https://reactjs.org/', rel: 'noopener' },
	        'React'
	      ),
	      ' | ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: 'https://www.gatsbyjs.org/', rel: 'noopener' },
	        'Gatsby'
	      ),
	      ' | ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: 'https://www.netlify.com/', rel: 'noopener' },
	        'Netlify'
	      ),
	      ' - 2018'
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 522:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(29);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(522);
	
	var _menuLogo = __webpack_require__(609);
	
	var _menuLogo2 = _interopRequireDefault(_menuLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Menu = function (_React$Component) {
	  _inherits(Menu, _React$Component);
	
	  function Menu(props) {
	    _classCallCheck(this, Menu);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.updateDimensions = function () {
	      _this.setState({ width: document.body.clientWidth });
	    };
	
	    _this.state = {
	      width: 0
	    };
	    return _this;
	  }
	
	  Menu.prototype.componentDidMount = function componentDidMount() {
	    this.updateDimensions();
	    window.addEventListener("resize", this.updateDimensions);
	  };
	
	  Menu.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateDimensions);
	  };
	
	  Menu.prototype.render = function render() {
	    var linkStyle = {
	      display: 'flex',
	      justifyContent: 'center',
	      backgroundImage: 'none',
	      color: '#5799a9'
	    };
	
	    if (this.state.width > 560) {
	      return _react2.default.createElement(
	        'ul',
	        {
	          style: {
	            width: '100%',
	            lineHeight: 'normal',
	            margin: '0',
	            marginLeft: 16,
	            display: 'flex',
	            justifyContent: 'flex-end',
	            alignItems: 'center',
	            listStyleType: 'none',
	            color: 'white'
	          }
	        },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/about/',
	            style: { color: 'white', textShadow: 'none' }
	          },
	          _react2.default.createElement(
	            'li',
	            null,
	            'About'
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/ux-design/',
	            style: { color: 'white', textShadow: 'none' }
	          },
	          _react2.default.createElement(
	            'li',
	            null,
	            'UX'
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/dev-stack/',
	            style: { color: 'white', textShadow: 'none' }
	          },
	          _react2.default.createElement(
	            'li',
	            null,
	            'Dev'
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/blog/',
	            style: { color: 'white', textShadow: 'none' }
	          },
	          _react2.default.createElement(
	            'li',
	            null,
	            'Blog'
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/contact/',
	            style: { color: 'white', textShadow: 'none' }
	          },
	          _react2.default.createElement(
	            'li',
	            null,
	            'Contact'
	          )
	        )
	      );
	    } else {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'mobile-app-bar',
	          style: {
	            position: 'fixed',
	            display: 'flex',
	            justifyContent: 'center',
	            height: '60px',
	            bottom: 0,
	            left: 0,
	            width: '100%',
	            background: '#eee',
	            fontFamily: 'sans-serif'
	          }
	        },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/about/',
	            style: linkStyle
	          },
	          _react2.default.createElement(
	            'span',
	            null,
	            'About'
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/ux-design/',
	            style: linkStyle
	          },
	          _react2.default.createElement(
	            'span',
	            null,
	            'UX'
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/dev-stack/',
	            style: linkStyle
	          },
	          _react2.default.createElement(
	            'span',
	            null,
	            'Dev'
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/blog/',
	            style: linkStyle
	          },
	          _react2.default.createElement(
	            'span',
	            null,
	            'Blog'
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/contact/',
	            style: linkStyle
	          },
	          _react2.default.createElement(
	            'span',
	            null,
	            'Contact'
	          )
	        )
	      );
	    }
	  };
	
	  return Menu;
	}(_react2.default.Component);
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'header',
	      style: {
	        background: '#5799a9',
	        marginBottom: '1.45rem',
	        boxShadow: '0px 2px 5px 0px rgba(186,186,186,1)'
	
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          display: 'flex',
	          margin: '0 auto',
	          maxWidth: 960,
	          padding: '1.10rem 1rem'
	        }
	      },
	      _react2.default.createElement(
	        'span',
	        { style: { margin: 0 } },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/',
	            style: {
	              color: 'white',
	              textShadow: 'none'
	            }
	          },
	          _react2.default.createElement(
	            'svg',
	            { style: {
	                width: 150,
	                height: 50
	              } },
	            _react2.default.createElement('use', { xlinkHref: '#' + _menuLogo2.default.id })
	          )
	        )
	      ),
	      _react2.default.createElement(Menu, null)
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(261);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(260);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(523);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Samuel Abiassi - Web Developer and UX/UI Designer',
	      meta: [{ name: 'description', content: 'Portfolio of Samuel Abiassi - Web Developer and UX/UI Designer - I mainly use JavaScript frameworks (Angular5, Vue, React) and Adobe XD  – Living in Grenoble (France) – Don’t hesitate to contact me for business projects' }, { name: 'keywords', content: 'samuel, abiassi, portfolio, ux, design, web, developer, javascript, react, grenoble' }]
	    }),
	    _react2.default.createElement(_Header2.default, null),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '0 auto',
	          maxWidth: 960,
	          padding: '0px 1.0875rem 1.45rem',
	          paddingTop: 0
	        }
	      },
	      children()
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 523:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(170);
	var sprite = __webpack_require__(171);
	var symbol = new SpriteSymbol({
	  "id": "menu-logo",
	  "use": "menu-logo-usage",
	  "viewBox": "0 0 141.05 54.55",
	  "content": "<symbol viewBox=\"0 0 141.05 54.55\" id=\"menu-logo\"><defs><style>#menu-logo .cls-1{fill:#589aa9;}#menu-logo .cls-2{fill:#fcfdfe;}#menu-logo .cls-3{fill:#f6f9fb;}</style></defs><title>Samuel Abiassi-Guillon</title><g id=\"menu-logo_Calque_2\" data-name=\"Calque 2\"><g id=\"menu-logo_Calque_1-2\" data-name=\"Calque 1\"><path class=\"cls-1\" d=\"M70.76,54.75q-34.74,0-69.48,0c-.8,0-1.06-.08-1.06-1q.06-26.3,0-52.61c0-.82.24-.94,1-.94q69.54,0,139.08,0c.93,0,1,.28,1,1.06q0,26.24,0,52.48c0,.89-.22,1-1,1Q105.49,54.73,70.76,54.75Zm9.13-22.84c.15.37.24.6.33.84C81,35.07,82,35.61,84.39,35a13.72,13.72,0,0,0,4.22-1.84c.54-.35.88-.38,1.35.16a6.34,6.34,0,0,0,6,2,13.3,13.3,0,0,0,6.13-2.63c.84-.63,1.13-.46,1.58.4,1.17,2.29,2.34,2.72,4.8,1.94a16.55,16.55,0,0,0,4-1.95c3.21-2.1,2.63-1,1.4-4.56-.23-.66-.51-.72-1.06-.28a19.57,19.57,0,0,1-3.55,2.32c-1.73.85-2.45.42-2.52-1.53A7.85,7.85,0,0,1,108,25a116.23,116.23,0,0,0,5.9-11.57,18.7,18.7,0,0,0,1.66-8.14c-.08-1.26-.2-2.61-1.57-3.17a3.61,3.61,0,0,0-3.61.79,11.29,11.29,0,0,0-3.11,3.71,38.36,38.36,0,0,0-5.14,20.81c0,.47.08.91-.36,1.24A14.23,14.23,0,0,1,96,31.57a2.5,2.5,0,0,1-2.25-.42c-.84-.73-.81-1,.23-1.37a10.29,10.29,0,0,0,4.93-3.68,4.74,4.74,0,0,0,.37-5.5A4.81,4.81,0,0,0,94,18.8a5.55,5.55,0,0,0-2.8,1.56,10.75,10.75,0,0,0-3,8.32c0,.71,0,1.3-.73,1.64-1,.46-2.12,1.61-3.19.92s-.57-2.21-.39-3.37c.37-2.43.82-4.84,1.23-7.26.09-.54.16-1.12-.35-1.5a3,3,0,0,0-2.64-.3c-.8.19-1.08.78-1.22,1.55-.46,2.54-1,5.07-1.47,7.6a4.6,4.6,0,0,1-1.56,3,1.27,1.27,0,0,1-1.38.32,1.38,1.38,0,0,1-.67-1.26,3.45,3.45,0,0,1,.09-.86c.48-3,.93-6,1.45-9,.17-1-.16-1.37-1.11-1.48a2.54,2.54,0,0,0-2.66,1.46,9,9,0,0,0-1,3.07,45.88,45.88,0,0,0-.75,4.68c-.12,1.8-1.36,2.44-2.68,3.09-.81.4-1.26,0-1.46-.76a10.14,10.14,0,0,1,0-3.23c.18-2.07.66-4.11.65-6.21,0-.91-.12-1.67-1.09-2a2.1,2.1,0,0,0-2.47.69,28.31,28.31,0,0,0-2.35,3.38L60.7,25.55c.08-1.64.56-3.15.69-4.72a1.78,1.78,0,0,0-.83-1.94,2.06,2.06,0,0,0-2.24.15,4.26,4.26,0,0,0-1.19,1.27c-.91,1.45-1.8,2.9-2.71,4.34-.15.24-.16.67-.66.61.17-1.58.42-3.14.5-4.71.09-1.73-.85-2.36-2.51-1.83a1.92,1.92,0,0,0-1.18,1.5,33.24,33.24,0,0,0-1.47,7.46c-.15,1.89-1.32,2.78-2.72,3.56-.84.47-1.36.13-1.46-.81A12.78,12.78,0,0,1,45.15,27a37.53,37.53,0,0,0,.81-5.3c0-1.12-.42-1.75-1.63-1.66-.54,0-1.17.11-1.52-.37-1.06-1.41-2.36-1-3.6-.5a11.15,11.15,0,0,0-5.59,5.49c-.45.85-.81,1.74-1.24,2.67a13.35,13.35,0,0,0-5.9-6.41c-2-1.21-4.09-2.24-6.19-3.26a19.81,19.81,0,0,1-5.06-3.18C12.37,11.76,13,8.5,16.56,6.91a12.43,12.43,0,0,1,8-.47c4.33,1,5.4,3.52,3.14,7.35a6.83,6.83,0,0,0-1.08,2.77,1.43,1.43,0,0,0,1.72,1.72,4.35,4.35,0,0,0,2.61-1.35c4.4-4.3,3.53-10.68-1.88-13.81C24,.23,16.11.71,11.49,4.19c-4.78,3.6-4.91,9.5-.31,13.33a36.32,36.32,0,0,0,6.26,3.86c2.71,1.45,5.62,2.58,7.86,4.8,2.55,2.53,2.42,5.71-.3,8.05-3.18,2.74-9.65,3.48-13.38,1.53A5.09,5.09,0,0,1,8.68,30.1c.11-.82.29-1.64.4-2.46.21-1.53-.62-2.33-2.14-2a4.77,4.77,0,0,0-3.7,4,8.91,8.91,0,0,0,4.26,9.52c4.62,2.9,9.67,3.17,14.83,2,4.59-1.08,8.28-3.41,10-8.14,2.47,3,4.77,3.3,7.94,1.06a3.07,3.07,0,0,0,.59-.46c.62-.73,1-.71,1.49.21,1,1.78,2.48,2.21,4.36,1.4a10.16,10.16,0,0,0,1.51-.87c.35-.23.55-.33.91.09C50.57,36,52,35.8,53,33.8c1.1-2.24,2.16-4.51,3.25-6.75a3.81,3.81,0,0,1,1.11-1.65c-.11.83-.2,1.39-.26,1.95-.23,2.14-.89,4.25-.43,6.44.15.73.44,1.4,1.23,1.58a2.36,2.36,0,0,0,2.28-.7,3.3,3.3,0,0,0,.66-1.19q1.33-3.44,2.7-6.86c.15-.37.17-.85.73-1.14-.06.59-.12,1-.15,1.49a20.1,20.1,0,0,0,.29,6.58c.45,1.58,1.2,2,2.76,1.83a8.39,8.39,0,0,0,3.78-1.53c.28-.19.51-.52.91,0,1.53,1.9,2.79,2.08,4.92.83A16.35,16.35,0,0,0,79.88,31.91ZM95.84,47H94.09c-.5,0-.61.3-.61.74s.22.59.62.59a7.17,7.17,0,0,1,1.25,0c.5.09,1.28-.39,1.43.51a1.71,1.71,0,0,1-1,2.15c-3.68,1.73-6.87-.34-6.67-4.41.08-1.68.58-3.18,2.32-3.79s3.48-.55,4.76,1.06c.54.68,1.12.35,1.53.05s-.06-.75-.28-1c-1.4-1.75-3.34-1.87-5.34-1.66a5,5,0,0,0-4.61,4.9c-.21,3.61,1.19,6,4,6.56a8.05,8.05,0,0,0,4.9-.46,2.57,2.57,0,0,0,1.86-2.82C98.16,47,98.27,47,95.84,47ZM33.63,49.41a6.76,6.76,0,0,0,1,0,1.67,1.67,0,0,1,2.15,1.44,6.68,6.68,0,0,0,.6,1.5c.3.6.9.44,1.33.31s.15-.64,0-.93c-1.27-3.21-2.58-6.41-3.85-9.62a1.13,1.13,0,0,0-1.2-.83,1.19,1.19,0,0,0-1.3.87c-1.28,3.21-2.61,6.4-3.9,9.6-.11.28-.54.74,0,.91.43.13,1,.27,1.34-.3a6.3,6.3,0,0,0,.34-.8c.87-2.15.87-2.15,3.14-2.15Zm8.19,2.45c2.52,1.78,5,1.06,5.6-1.6a8.94,8.94,0,0,0,0-4.2,2.85,2.85,0,0,0-3-2.3,4.49,4.49,0,0,0-2.64,1c0-1.11,0-2.06,0-3,0-.55.07-1.09-.79-1.07s-.77.57-.77,1.11c0,3.24,0,6.48,0,9.72,0,.43-.25,1,.53,1.18S41.68,52.43,41.82,51.87Zm16.48-.55a1.8,1.8,0,0,0,2.33,1.41.52.52,0,0,0,.51-.46c0-.22,0-.46-.27-.49-1.23-.17-1-1.12-1-1.92,0-1,0-2,0-3,0-1.6-.55-2.45-1.74-2.86-1.61-.55-3.77-.18-4.54.85-.27.36-.8.87-.23,1.26a.94.94,0,0,0,1.46-.37,2.13,2.13,0,0,1,2.67-.58,1.49,1.49,0,0,1,.81,1.68c-.11.74-.78.46-1.22.48a7.63,7.63,0,0,0-2.94.46,2.62,2.62,0,0,0-1.42,3.14,2.24,2.24,0,0,0,2.4,1.9A3.63,3.63,0,0,0,58.3,51.31Zm73.09-6.23c-.11-.7-.12-1.25-.91-1.16s-.6.67-.61,1.11q0,3.25,0,6.49c0,.53-.21,1.22.77,1.21s.78-.66.79-1.21c0-1.5,0-3,.06-4.49A2.1,2.1,0,0,1,133.83,45c1.39.08,1.52,1.08,1.53,2.13,0,1.54,0,3.08,0,4.62,0,.51,0,1,.74,1s.79-.42.79-1c0-1.75,0-3.5,0-5.25-.06-2-1-2.84-3-2.75A3.48,3.48,0,0,0,131.39,45.08ZM120.3,48.19c0,2.93,1.14,4.49,3.41,4.61,3,.16,4.6-1.5,4.44-4.73-.13-2.47-.85-3.66-2.51-4.12C122.42,43.07,120.32,44.74,120.3,48.19ZM65.07,52.8h.37c2,0,3.11-.8,3.3-2.2s-.6-2.34-2.61-2.92c-.68-.19-1.36-.38-2-.62a1,1,0,0,1-.73-1,1,1,0,0,1,.88-.93c1-.21,2.08-.29,2.84.7a.85.85,0,0,0,1.23.14c.45-.34,0-.79-.2-1.07-1.07-1.22-2.5-1.2-3.92-1s-2.24,1-2.32,2.18.49,1.92,1.92,2.41c.9.31,1.84.54,2.73.86a1.13,1.13,0,0,1-.17,2.15c-1.21.29-2.42.42-3.31-.72a.83.83,0,0,0-1.3-.13c-.4.35,0,.78.26,1.08A3.47,3.47,0,0,0,65.07,52.8Zm8.28,0H74c1.75-.08,2.85-.9,3-2.24s-.53-2.23-2.3-2.78c-.75-.24-1.52-.42-2.27-.68A1,1,0,0,1,71.63,46a1,1,0,0,1,.92-.89,2.56,2.56,0,0,1,2.75.67.83.83,0,0,0,1.31.12c.36-.36,0-.8-.31-1.08a4,4,0,0,0-3.6-1c-1.67.16-2.49.92-2.58,2.2s.54,2,2.13,2.52c.83.27,1.68.47,2.5.78a1.07,1.07,0,0,1,.74,1.18,1.11,1.11,0,0,1-1,1c-1.22.27-2.42.36-3.28-.81A.82.82,0,0,0,70,50.59c-.51.35,0,.75.18,1A3.4,3.4,0,0,0,73.35,52.8Zm32.58-1c.21.56.39,1.14,1.18.95.39-.1.42-.33.42-.64,0-2.5,0-5,0-7.5,0-.5-.25-.65-.7-.64s-.76.07-.77.59c0,.33,0,.67,0,1a26,26,0,0,1-.13,4.36,2,2,0,0,1-2.37,1.72c-1.3-.11-1.48-1-1.48-2,0-1.5,0-3,0-4.5,0-.51.18-1.12-.72-1.13s-.81.5-.81,1.07c0,1.62,0,3.25,0,4.87.07,2.39,1.39,3.37,3.72,2.87A5.29,5.29,0,0,0,105.92,51.77Zm9-5q0-2.55,0-5.1c0-.51,0-1-.74-1s-.76.42-.76,1q0,5,0,10.08c0,.5-.07,1,.72,1s.78-.54.78-1.08Q114.93,49.23,114.93,46.8Zm3.65-.05c0-1.62,0-3.24,0-4.86,0-.57.12-1.2-.82-1.18s-.74.6-.74,1.12q0,4.86,0,9.73c0,.56-.16,1.21.8,1.18s.74-.71.75-1.24C118.6,49.91,118.58,48.33,118.58,46.75ZM50.89,48.32c0-1.16,0-2.33,0-3.49,0-.61-.14-.93-.83-.91s-.78.26-.77.84c0,2.37,0,4.74,0,7.11,0,.53.12.85.76.87s.85-.33.84-.92C50.87,50.65,50.89,49.49,50.89,48.32Zm27.7,0c0,1.17,0,2.33,0,3.5,0,.63.21.9.87.89s.74-.36.74-.88c0-2.37,0-4.75,0-7.12,0-.6-.23-.8-.81-.8s-.83.2-.81.8C78.6,45.93,78.58,47.14,78.58,48.35Zm31.15,0c0,1.17,0,2.33,0,3.5,0,.54.12.86.76.86s.75-.36.75-.88c0-2.37,0-4.75,0-7.12,0-.6-.27-.8-.84-.79s-.67.34-.67.81C109.74,46,109.73,47.17,109.73,48.37ZM83.92,49h1.36c.45,0,.69-.16.69-.65s-.17-.78-.71-.77H82.54c-.51,0-.61.3-.61.72s.12.72.63.69S83.47,49,83.92,49ZM50,40.72c-.48-.09-.67.16-.69.68s.34.73.85.74.73-.19.75-.72S50.56,40.66,50,40.72Zm30.19.69c.08-.49-.19-.69-.71-.7s-.89.08-.88.73.32.7.8.69S80.23,42.07,80.17,41.41Zm31,0c.06-.5-.13-.77-.68-.74s-.81,0-.83.61.13.85.74.82S111.28,42,111.22,41.45Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-2\" d=\"M79.88,31.91a16.35,16.35,0,0,1-3.11,2.76c-2.12,1.26-3.39,1.08-4.92-.83-.4-.5-.63-.18-.91,0a8.39,8.39,0,0,1-3.78,1.53c-1.56.2-2.32-.25-2.76-1.83A20.1,20.1,0,0,1,64.11,27c0-.45.09-.9.15-1.49-.55.3-.58.77-.73,1.14q-1.37,3.42-2.7,6.86a3.3,3.3,0,0,1-.66,1.19,2.36,2.36,0,0,1-2.28.7c-.79-.18-1.08-.85-1.23-1.58-.46-2.19.2-4.3.43-6.44.06-.56.15-1.11.26-1.95A3.81,3.81,0,0,0,56.24,27c-1.1,2.25-2.15,4.51-3.25,6.75-1,2-2.42,2.22-3.84.56-.36-.42-.56-.32-.91-.09a10.16,10.16,0,0,1-1.51.87c-1.88.81-3.38.38-4.36-1.4-.51-.92-.87-.94-1.49-.21a3.07,3.07,0,0,1-.59.46c-3.17,2.24-5.48,1.95-7.94-1.06-1.72,4.72-5.41,7.05-10,8.14-5.16,1.22-10.21.94-14.83-2A8.91,8.91,0,0,1,3.24,29.6a4.77,4.77,0,0,1,3.7-4c1.52-.33,2.34.47,2.14,2-.11.82-.29,1.64-.4,2.46a5.09,5.09,0,0,0,2.94,5.66c3.73,2,10.2,1.21,13.38-1.53,2.72-2.34,2.85-5.52.3-8.05-2.23-2.22-5.15-3.35-7.86-4.8a36.32,36.32,0,0,1-6.26-3.86c-4.6-3.83-4.47-9.73.31-13.33C16.11.71,24,.23,29,3.13c5.41,3.14,6.28,9.52,1.88,13.81a4.35,4.35,0,0,1-2.61,1.35,1.43,1.43,0,0,1-1.72-1.72,6.83,6.83,0,0,1,1.08-2.77c2.26-3.83,1.19-6.36-3.14-7.35a12.43,12.43,0,0,0-8,.47C13,8.5,12.37,11.76,15.23,14.45a19.81,19.81,0,0,0,5.06,3.18c2.1,1,4.19,2,6.19,3.26a13.35,13.35,0,0,1,5.9,6.41c.43-.94.8-1.83,1.24-2.67a11.15,11.15,0,0,1,5.59-5.49c1.24-.51,2.55-.92,3.6.5.35.47,1,.4,1.52.37,1.21-.09,1.65.54,1.63,1.66a37.53,37.53,0,0,1-.81,5.3,12.78,12.78,0,0,0-.25,3.48c.1.94.62,1.28,1.46.81,1.41-.78,2.58-1.67,2.72-3.56a33.24,33.24,0,0,1,1.47-7.46,1.92,1.92,0,0,1,1.18-1.5c1.66-.53,2.61.1,2.51,1.83-.09,1.57-.33,3.13-.5,4.71.51.06.51-.37.66-.61.92-1.44,1.8-2.9,2.71-4.34a4.26,4.26,0,0,1,1.19-1.27,2.06,2.06,0,0,1,2.24-.15,1.78,1.78,0,0,1,.83,1.94c-.13,1.57-.61,3.08-.69,4.72l1.71-2.69a28.31,28.31,0,0,1,2.35-3.38,2.1,2.1,0,0,1,2.47-.69c1,.33,1.09,1.1,1.09,2,0,2.1-.48,4.14-.65,6.21a10.14,10.14,0,0,0,0,3.23c.19.81.64,1.16,1.46.76,1.32-.65,2.56-1.29,2.68-3.09a45.88,45.88,0,0,1,.75-4.68,9,9,0,0,1,1-3.07,2.54,2.54,0,0,1,2.66-1.46c.95.11,1.29.49,1.11,1.48-.52,3-1,6-1.45,9a3.45,3.45,0,0,0-.09.86,1.38,1.38,0,0,0,.67,1.26A1.27,1.27,0,0,0,77.91,31a4.6,4.6,0,0,0,1.56-3c.49-2.53,1-5.06,1.47-7.6.14-.77.42-1.37,1.22-1.55a3,3,0,0,1,2.64.3c.51.38.44,1,.35,1.5-.41,2.42-.86,4.84-1.23,7.26-.18,1.16-.75,2.63.39,3.37s2.14-.46,3.19-.92c.78-.34.76-.93.73-1.64a10.75,10.75,0,0,1,3-8.32A5.55,5.55,0,0,1,94,18.8a4.81,4.81,0,0,1,5.21,1.82,4.74,4.74,0,0,1-.37,5.5,10.29,10.29,0,0,1-4.93,3.68c-1,.4-1.07.64-.23,1.37a2.5,2.5,0,0,0,2.25.42,14.23,14.23,0,0,0,5.76-2.87c.44-.33.39-.76.36-1.24a38.36,38.36,0,0,1,5.14-20.81,11.29,11.29,0,0,1,3.11-3.71A3.61,3.61,0,0,1,114,2.15c1.38.56,1.5,1.91,1.57,3.17a18.7,18.7,0,0,1-1.66,8.14A116.23,116.23,0,0,1,108,25a7.85,7.85,0,0,0-1.19,4c.07,2,.79,2.38,2.52,1.53a19.57,19.57,0,0,0,3.55-2.32c.55-.44.83-.37,1.06.28,1.23,3.58,1.81,2.46-1.4,4.56a16.55,16.55,0,0,1-4,1.95c-2.46.78-3.63.35-4.8-1.94-.44-.87-.73-1-1.58-.4A13.3,13.3,0,0,1,96,35.34a6.34,6.34,0,0,1-6-2c-.47-.54-.81-.51-1.35-.16A13.72,13.72,0,0,1,84.39,35c-2.37.58-3.36,0-4.18-2.29C80.13,32.51,80,32.28,79.88,31.91ZM36.52,29.66a4.85,4.85,0,0,0,0,.62c.09.72.27,1.45,1.08,1.66s1.25-.32,1.66-.87a7.15,7.15,0,0,0,1.23-2.71c.38-1.66.72-3.33,1.05-5,.08-.39.43-.89,0-1.15s-.89.07-1.26.33C37.82,24.26,36.84,26.79,36.52,29.66Zm70.15-9A38,38,0,0,0,111.74,8.5c.12-.62.47-1.63-.13-1.84-.77-.28-1.21.69-1.57,1.3A26.69,26.69,0,0,0,106.66,20.71ZM92.51,26.14c.06.47-.17,1.17.72.9a5.16,5.16,0,0,0,3.25-2.55,1.7,1.7,0,0,0-.35-2.18c-.68-.56-1.45-.19-2.06.29A4.92,4.92,0,0,0,92.51,26.14Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M95.84,47c2.43,0,2.32,0,2.47,2.41a2.57,2.57,0,0,1-1.86,2.82,8.05,8.05,0,0,1-4.9.46c-2.84-.6-4.24-2.95-4-6.56a5,5,0,0,1,4.61-4.9c2-.22,3.95-.1,5.34,1.66.22.28.77.68.28,1s-1,.63-1.53-.05c-1.28-1.61-3-1.67-4.76-1.06s-2.24,2.11-2.32,3.79c-.2,4.07,3,6.14,6.67,4.41a1.71,1.71,0,0,0,1-2.15c-.16-.9-.93-.42-1.43-.51a7.17,7.17,0,0,0-1.25,0c-.4,0-.62-.15-.62-.59s.1-.74.61-.74Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M33.63,49.41h-.25c-2.27,0-2.27,0-3.14,2.15a6.3,6.3,0,0,1-.34.8c-.33.57-.91.42-1.34.3-.58-.17-.15-.63,0-.91,1.29-3.2,2.62-6.39,3.9-9.6a1.19,1.19,0,0,1,1.3-.87,1.13,1.13,0,0,1,1.2.83c1.27,3.21,2.58,6.41,3.85,9.62.11.29.53.75,0,.93s-1,.29-1.33-.31a6.68,6.68,0,0,1-.6-1.5,1.67,1.67,0,0,0-2.15-1.44A6.76,6.76,0,0,1,33.63,49.41Zm0-6.58c-.41,1.07-.69,1.8-1,2.53-1.2,3.05-1.13,3.14,2.16,2.78.49-.05.83-.12.59-.74C34.87,46,34.32,44.57,33.65,42.83Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M41.82,51.87c-.15.56-.41,1-1.09.85s-.53-.75-.53-1.18c0-3.24,0-6.48,0-9.72,0-.54-.08-1.09.77-1.11s.79.51.79,1.07c0,1,0,1.91,0,3a4.49,4.49,0,0,1,2.64-1,2.85,2.85,0,0,1,3,2.3,8.94,8.94,0,0,1,0,4.2C46.83,52.92,44.35,53.65,41.82,51.87Zm4.24-3.41c-.06-.65-.07-1.19-.17-1.72-.19-1-.66-1.72-1.78-1.76a2,2,0,0,0-2.17,1.63A6.82,6.82,0,0,0,42,50.29a1.89,1.89,0,0,0,2.09,1.4,1.69,1.69,0,0,0,1.72-1.5C45.93,49.58,46,49,46.06,48.45Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M58.3,51.31a3.63,3.63,0,0,1-3.23,1.5,2.24,2.24,0,0,1-2.4-1.9,2.62,2.62,0,0,1,1.42-3.14A7.63,7.63,0,0,1,57,47.31c.44,0,1.11.26,1.22-.48a1.49,1.49,0,0,0-.81-1.68,2.13,2.13,0,0,0-2.67.58.94.94,0,0,1-1.46.37c-.57-.39,0-.9.23-1.26.77-1,2.93-1.4,4.54-.85,1.19.41,1.71,1.26,1.74,2.86,0,1,0,2,0,3,0,.81-.19,1.75,1,1.92.25,0,.3.27.27.49a.52.52,0,0,1-.51.46A1.8,1.8,0,0,1,58.3,51.31Zm-1.49-2.88a9.71,9.71,0,0,0-1.32.16,1.61,1.61,0,0,0-1.26,2.08c.31,1,1.1,1.11,2,.93a2.51,2.51,0,0,0,1.67-1.2,1.74,1.74,0,0,0,.3-1.65C57.94,48.2,57.31,48.56,56.81,48.43Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M131.39,45.08a3.48,3.48,0,0,1,2.47-1.31c2-.09,3,.73,3,2.75.05,1.75,0,3.5,0,5.25,0,.55,0,1-.79,1s-.74-.5-.74-1c0-1.54,0-3.08,0-4.62,0-1-.14-2.05-1.53-2.13A2.1,2.1,0,0,0,131.49,47c-.1,1.49,0,3-.06,4.49,0,.55.18,1.21-.79,1.21s-.77-.68-.77-1.21q0-3.25,0-6.49c0-.45-.21-1,.61-1.11S131.28,44.38,131.39,45.08Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M120.3,48.19c0-3.46,2.12-5.13,5.34-4.23,1.65.46,2.38,1.65,2.51,4.12.17,3.23-1.39,4.89-4.44,4.73C121.44,52.68,120.29,51.12,120.3,48.19Zm6.21.11a5.47,5.47,0,0,0-.24-2A1.85,1.85,0,0,0,124.44,45a2,2,0,0,0-2.21,1.22,5.92,5.92,0,0,0,0,4.36,1.86,1.86,0,0,0,1.89,1.15,2,2,0,0,0,2-1.2A4.85,4.85,0,0,0,126.51,48.3Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M65.07,52.81a3.48,3.48,0,0,1-3-1.09c-.24-.3-.66-.73-.26-1.08a.83.83,0,0,1,1.3.13c.89,1.14,2.1,1,3.31.72a1.13,1.13,0,0,0,.17-2.15c-.9-.33-1.83-.55-2.73-.86-1.43-.49-2-1.22-1.92-2.41s.81-2,2.32-2.18,2.86-.23,3.92,1c.25.28.65.73.2,1.07a.85.85,0,0,1-1.23-.14c-.76-1-1.8-.91-2.84-.7a1,1,0,0,0-.88.93,1,1,0,0,0,.73,1c.66.24,1.35.43,2,.62,2,.58,2.81,1.46,2.61,2.92s-1.34,2.17-3.3,2.2Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M73.35,52.8a3.4,3.4,0,0,1-3.14-1.16c-.21-.29-.69-.69-.18-1a.82.82,0,0,1,1.22.12c.87,1.17,2.06,1.08,3.28.81a1.11,1.11,0,0,0,1-1,1.07,1.07,0,0,0-.74-1.18c-.82-.31-1.67-.51-2.5-.78C70.66,48,70,47.28,70.12,46s.91-2,2.58-2.2a4,4,0,0,1,3.6,1c.26.28.68.72.31,1.08a.83.83,0,0,1-1.31-.12,2.56,2.56,0,0,0-2.75-.67,1,1,0,0,0-.92.89,1,1,0,0,0,.77,1.14c.75.25,1.52.44,2.27.68,1.77.56,2.46,1.4,2.3,2.78s-1.25,2.16-3,2.24Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M105.92,51.77a5.29,5.29,0,0,1-1.67,1c-2.33.51-3.65-.48-3.72-2.87,0-1.62,0-3.25,0-4.87,0-.57,0-1.08.81-1.07s.71.63.72,1.13c0,1.5,0,3,0,4.5,0,1,.18,1.94,1.48,2a2,2,0,0,0,2.37-1.72,26,26,0,0,0,.13-4.36c0-.33,0-.67,0-1,0-.52.35-.58.77-.59s.7.14.7.64c0,2.5,0,5,0,7.5,0,.3,0,.54-.42.64C106.32,52.91,106.14,52.33,105.92,51.77Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M114.93,46.8q0,2.43,0,4.85c0,.54.08,1.09-.78,1.08s-.72-.5-.72-1q0-5,0-10.08c0-.54,0-1,.76-1s.74.49.74,1Q114.93,44.25,114.93,46.8Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M118.58,46.75c0,1.58,0,3.16,0,4.74,0,.53.22,1.22-.75,1.24s-.8-.62-.8-1.18q0-4.86,0-9.73c0-.52-.14-1.1.74-1.12s.82.61.82,1.18C118.59,43.51,118.58,45.13,118.58,46.75Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M50.89,48.32c0,1.16,0,2.33,0,3.49,0,.59-.14.93-.84.92s-.76-.33-.76-.87c0-2.37,0-4.74,0-7.11,0-.57.16-.82.77-.84s.84.3.83.91C50.87,46,50.89,47.16,50.89,48.32Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M78.58,48.35c0-1.21,0-2.42,0-3.62,0-.6.24-.8.81-.8s.81.2.81.8c0,2.37,0,4.75,0,7.12,0,.52-.1.87-.74.88s-.88-.26-.87-.89C78.6,50.68,78.58,49.51,78.58,48.35Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M109.73,48.37c0-1.21,0-2.42,0-3.62,0-.47.08-.81.67-.81s.84.19.84.79c0,2.37,0,4.75,0,7.12,0,.52-.1.88-.75.88s-.77-.32-.76-.86C109.74,50.71,109.73,49.54,109.73,48.37Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M83.92,49c-.45,0-.91,0-1.36,0s-.63-.26-.63-.69.1-.73.61-.72h2.73c.54,0,.72.26.71.77s-.25.65-.69.65Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M50,40.72c.58-.06.93,0,.91.7s-.24.73-.75.72-.87-.09-.85-.74S49.5,40.63,50,40.72Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M80.17,41.41c.06.66-.34.72-.8.73s-.79-.11-.8-.69.35-.74.88-.73S80.25,40.92,80.17,41.41Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-3\" d=\"M111.22,41.45c.06.58-.3.67-.76.69s-.75-.27-.74-.82.4-.59.83-.61S111.28,41,111.22,41.45Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-1\" d=\"M36.52,29.66c.33-2.87,1.3-5.4,3.78-7.12.37-.26.86-.59,1.26-.33s.07.77,0,1.15c-.34,1.67-.67,3.34-1.05,5a7.15,7.15,0,0,1-1.23,2.71c-.41.55-.91,1.06-1.66.87s-1-.93-1.08-1.66A4.85,4.85,0,0,1,36.52,29.66Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-1\" d=\"M106.66,20.71A26.69,26.69,0,0,1,110,8c.36-.61.8-1.58,1.57-1.3.59.22.25,1.22.13,1.84A38,38,0,0,1,106.66,20.71Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-1\" d=\"M92.51,26.14a4.92,4.92,0,0,1,1.56-3.54c.61-.47,1.37-.84,2.06-.29a1.7,1.7,0,0,1,.35,2.18A5.16,5.16,0,0,1,93.23,27C92.34,27.31,92.57,26.6,92.51,26.14Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-1\" d=\"M33.65,42.83c.67,1.74,1.22,3.16,1.77,4.57.24.61-.1.68-.59.74-3.28.35-3.35.27-2.16-2.78C33,44.63,33.24,43.9,33.65,42.83Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-1\" d=\"M46.06,48.45c-.07.51-.13,1.13-.25,1.74a1.69,1.69,0,0,1-1.72,1.5A1.89,1.89,0,0,1,42,50.29a6.82,6.82,0,0,1-.06-3.68A2,2,0,0,1,44.11,45c1.11,0,1.59.79,1.78,1.76C46,47.26,46,47.81,46.06,48.45Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-1\" d=\"M56.81,48.43c.5.13,1.13-.23,1.39.32a1.74,1.74,0,0,1-.3,1.65,2.51,2.51,0,0,1-1.67,1.2c-.9.19-1.69.11-2-.93a1.61,1.61,0,0,1,1.26-2.08A9.71,9.71,0,0,1,56.81,48.43Z\" transform=\"translate(-0.22 -0.22)\" /><path class=\"cls-1\" d=\"M126.51,48.3a4.84,4.84,0,0,1-.34,2.19,2,2,0,0,1-2,1.2,1.86,1.86,0,0,1-1.89-1.15,5.92,5.92,0,0,1,0-4.36A2,2,0,0,1,124.44,45a1.85,1.85,0,0,1,1.83,1.39A5.45,5.45,0,0,1,126.51,48.3Z\" transform=\"translate(-0.22 -0.22)\" /></g></g></symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-5fa582a1206cd55f9000.js